import { render, staticRenderFns } from "./overMedian.vue?vue&type=template&id=3508abc2&scoped=true&"
import script from "./overMedian.vue?vue&type=script&setup=true&lang=js&"
export * from "./overMedian.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508abc2",
  null
  
)

export default component.exports